export function formatOfflineMessage(template, orderNumber) {
  const msg = String(template || '').trim();
  if (!msg) return '';
  return msg.replace(/\{order_number\}/g, String(orderNumber || '').trim());
}
